export default {
      id: "logo-cb-full-white-usage",
      viewBox: "0 0 300.111 30",
      url: "/assets/svg/" + "sprite.svg#logo-cb-full-white-usage",
      toString: function () {
        return this.url;
      }
    }